import React, { useEffect } from 'react';

import { Box, Button, Stack } from '@sunwisesoftware/sunwise-ui';
import PropTypes from 'prop-types';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import ReactHookFormInput from 'common/components/form/ReactHookFormInput';
import ShowErrors from 'common/components/ShowErrors';
import yupResolver from 'common/utils/yupResolver';

import * as actions from '../actions';
import * as selectors from '../selectors';
import validate from '../validate';

const DataForm = ({ errors, handleClickSave, initialValues, isSaving }) => {
    const { t } = useTranslation();

    const { control, handleSubmit, reset } = useForm({
        defaultValues: initialValues,
        resolver: yupResolver(validate),
    });

    useEffect(() => reset(initialValues), [initialValues]);

    return (
        <Stack component="form" onSubmit={handleSubmit(handleClickSave)}>
            <ReactHookFormInput
                autoComplete="off"
                control={control}
                label={t('Password')}
                name="new_password"
                placeholder={t('Password')}
                type="password"
            />

            <ReactHookFormInput
                autoComplete="off"
                control={control}
                label={t('Confirm Password')}
                name="confirm_password"
                placeholder={t('Confirm Password')}
                type="password"
            />

            <ShowErrors errors={errors} />

            <Box textAlign="right">
                <Button disabled={isSaving} type="submit">
                    {t('Save')}
                </Button>
            </Box>
        </Stack>
    );
};

const mapStateToProps = createStructuredSelector({
    errors: selectors.getErrorsSave,
    initialValues: selectors.getInitialValues,
    isSaving: selectors.getIsSaving,
});

const mapDispatchToProps = (dispatch) => ({
    handleClickSave: (values) => dispatch(actions.save(values)),
});

DataForm.propTypes = {
    errors: PropTypes.array,
    handleClickSave: PropTypes.func,
    initialValues: PropTypes.object,
    isSaving: PropTypes.bool,
};

export default connect(mapStateToProps, mapDispatchToProps)(DataForm);
